import { render, staticRenderFns } from "./PlayerParticipations.vue?vue&type=template&id=06d60a87&"
import script from "./PlayerParticipations.vue?vue&type=script&lang=js&"
export * from "./PlayerParticipations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports